export const SET_UNITED_CARD_REESTR_FETCHING = 'SET_UNITED_CARD_REESTR_FETCHING';
	
export const SET_UNITED_CARD_REESTR_FETCHING_ERROR = 'SET_UNITED_CARD_REESTR_FETCHING_ERROR';
	
export const SET_UNITED_CARD_REESTR = 'SET_UNITED_CARD_REESTR';
	
export const CLEAN_UNITED_CARD_REESTR = 'CLEAN_UNITED_CARD_REESTR';
	
export const ABORT_UNITED_CARD_REESTR_REQUEST = 'ABORT_UNITED_CARD_REESTR_REQUEST';




// WEBPACK FOOTER //
// ./src/redux_related/unitedCardReestr/actions.js